import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tangshui",
  "use": "icon-tangshui-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-tangshui\"><defs><style type=\"text/css\"></style></defs><path d=\"M409.6 550.912l28.672 28.672c16.384 16.384 16.384 40.96 0 57.344L235.52 839.68c-16.384 16.384-40.96 16.384-57.344 0l-28.672-28.672c-16.384-16.384-16.384-40.96 0-57.344l202.752-202.752c16.384-16.384 43.008-16.384 57.344 0z\" fill=\"#8a8a8a\" opacity=\".3\" p-id=\"23666\" /><path d=\"M483.328 507.904c71.68 71.68 188.416 71.68 260.096 0s145.408-260.096 71.68-333.824C743.424 102.4 555.008 174.08 483.328 245.76s-71.68 190.464 0 262.144z\" fill=\"#8a8a8a\" p-id=\"23667\" /><path d=\"M747.52 247.808c38.912 45.056-4.096 155.648-47.104 198.656-40.96 40.96-106.496 43.008-149.504 8.192l196.608-206.848z\" fill=\"#ffffff\" p-id=\"23668\" data-spm-anchor-id=\"a313x.7781069.0.i18\" class=\"selected\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tangshui.svg
// module id = eJbH
// module chunks = 22